import {
  helpRequestConfig,
  helpRequest,
  CreateHelpRequestCustomer
} from 'src/app/queries/queries.js'

const getHelpRequestConfig = (id, success, error) => {
  return {
    type: 'API:HELPREQUESTCONFIG',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: helpRequestConfig,
      variables: { help_request_config_id: id }
    }
  }
}
const getHelpRequest = (id, success, error) => {
  return {
    type: 'API:HELPREQUEST',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: helpRequest,
      variables: { help_request_id: id }
    }
  }
}

const HelpRequestCustomer = (id, success, error) => {
  return {
    type: 'API:HELPREQUESTCUSTOMER',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: CreateHelpRequestCustomer,
      variables: { input: { help_request_id: id } }
    }
  }
}

export default {
  getHelpRequestConfig,
  getHelpRequest,
  HelpRequestCustomer
}
